import { useState } from 'react';

import { HotkeyBase, LayoutHotkeyNames } from '../../hotkeys/types.ts';
import { DefaultLayoutHotKeys } from './defaultHotKeys.ts';

export const useResolvedLayoutHotKeys: () => {
  resolvedLayoutHotKeys: Record<LayoutHotkeyNames, HotkeyBase>;
} = () => {
  // const [hotKeys, setHotKeys] =
  const [hotKeys] = useState<Record<LayoutHotkeyNames, HotkeyBase>>(DefaultLayoutHotKeys);

  // The intention of this file is to resolve custom hotkeys from localstorage
  // which in turn is set from the database and then use setHotKeys to update the hotkeys with the custom ones.
  // For now, we are directly using the default hotkeys as there is no backend support for custom hotkeys yet.
  // REMARK:
  return {
    resolvedLayoutHotKeys: hotKeys,
  };
};
